let actions = {
    fetchUser({ commit }) {
        return axios
            .get("/api/user", {})
            .then((data) => {
                commit("FETCH_USER", data);
            })
            .catch((error) => {});
    },
    fetchLocations({ commit }) {
        return axios
            .get("/api/locations", {})
            .then((data) => {
                commit("FETCH_LOCATIONS", data);
            })
            .catch((error) => {});
    },
    fetchJewelOptions({ commit }) {
        return axios
            .get("/api/jewel/options", {})
            .then((data) => {
                commit("FETCH_JEWEL_OPTIONS", data);
            })
            .catch((err) => {});
    },

    fetchValuationIndexOptions({ commit }) {
        return axios
            .get("/api/valuation-index/options", {})
            .then((data) => {
                commit("FETCH_VALUATION_INDEX_OPTIONS", data);
            })
            .catch((err) => {});
    },
    fetchValuationEstimate({ commit }, valuationRequest) {
        return axios
            .get("/api/valuation-estimate/calculate", {
                params: {
                    valuationRequest: valuationRequest,
                },
            })
            .then((data) => {
                commit("FETCH_VALUATION_ESTIMATE", data);
            })
            .catch((err) => {});
    },
    fetchValuationIndex({ commit }, valuationRequest) {
        return axios
            .get("/api/valuation-index/calculate", {
                params: {
                    valuationRequest: valuationRequest,
                },
            })
            .then((data) => {
                commit("FETCH_VALUATION_INDEX", data);
            })
            .catch((err) => {});
    },
    fetchValuationIndexTable({ commit }, data) {
        return axios
            .get("/api/valuation-index/table", {
                params: {
                    shape: data.shape,
                    index: data.index,
                    jurisdiction: data.jurisdiction,
                },
            })
            .then((data) => {
                commit("FETCH_VALUATION_INDEX_TABLES", data);
            })
            .catch((err) => {});
    },

    updateCertificateAutoRenew({ commit }, data) {
        return axios
            .post("/api/certificate/auto-renew", data)
            .then((data) => {
                return data;
            })
            .catch((err) => {});
    },
    checkEmail({ commit }, data) {
        return axios
            .post("/api/forms/check-email", data)
            .then((data) => {
                return data;
            })
            .catch((err) => {});
    },
};
export default actions;
